<template>
  <div class="add-components-container">
    <div class="menu-tab">
      <el-row>
        <el-button size="mini" @click="addComponent">添加组件</el-button>
        <el-button type="primary" size="mini" @click="toggleSelection(true)"
          >全选</el-button
        >
        <el-button type="success" size="mini" @click="toggleSelection(false)"
          >取消全选</el-button
        >
        <el-button type="info" size="mini" @click="delAll">删除</el-button>

        <el-select
          v-model="cateDetail"
          placeholder="选择分类"
          size="mini"
          style="margin-left: 20px"
          @change="changeCate"
          value-key="name"
        >
          <el-option
            v-for="item in cateList"
            :key="item.id"
            :label="item.name"
            :value="item"
          >
          </el-option>
        </el-select>
      </el-row>
    </div>
    <el-table
      v-loading="Loading"
      ref="multipleTable"
      :height="height"
      :data="
        tableData.filter(
          (data) =>
            !search || data.name.toLowerCase().includes(search.toLowerCase())
        )
      "
      class="table-content"
      style="width: 100%"
      @selection-change="selectChange"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column label="名称" prop="name"> </el-table-column>
      <el-table-column label="图标" prop="icon">
        <template slot-scope="scope">
          <el-image style="width: 50px; height: 50px" :src="scope.row.image" :preview-src-list="[scope.row.image]">
          </el-image>
        </template>
      </el-table-column>
      <el-table-column label="分类">
        <template slot-scope="scope">
          {{ cateDetail.name }}
        </template>
      </el-table-column>
      <el-table-column label="是否公开" name="elementType">
        <template slot-scope="scope">
          {{ scope.row.elementType === 1 ? "否" : "是" }}
        </template>
      </el-table-column>
      
      <el-table-column align="right">
        <template slot="header" slot-scope="scope">
          <el-input v-model="search" size="mini" placeholder="输入关键字搜索" />
        </template>
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.$index, scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      :title="currentType == diaglogType.add ? '添加组件' : '编辑组件'"
      :modal-append-to-body="false"
      :visible.sync="dialogVisible"
      width="30%"
      :destroy-on-close="true"
    >
      <div style="margin: 20px"></div>
      <el-form
        :label-position="labelPosition"
        label-width="80px"
        :model="formData"
        :rules="rules"
        ref="form"
      >
        <el-form-item label="组件图标">
          <el-upload
            :action="
              currentType == diaglogType.add ? urls.addUrl : urls.editUrl
            "
            list-type="picture-card"
            :multiple="true"
            :headers="headers"
            name="file"
            :limit="10"
            :accept="accept"
            :auto-upload="false"
            ref="upload"
            :data="formData"
            :file-list="filelist"
            :http-request="uploadHttpRequest"
            :before-upload="beforeUpload"
            :on-exceed="onexceed"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="组件名" prop="name">
          <el-input v-model="formData.name" placeholder="图片多选时组件名可任填，不管多选还差单选，组件名都是必填的"></el-input>
        </el-form-item>
        <el-form-item label="添加自定义属性" prop="Data">
          <div>
            <el-button
              icon="el-icon-plus"
              circle
              size="mini"
              @click="addProp"
              title="添加新属性"
            ></el-button>
          </div>
          <div class="prop-content">
            <div class="props-item">
              <div class="key-name">key</div>
              <div class="value-name">value</div>
            </div>
            <div class="props-item" v-for="(item, index) in props">
              <div class="key-name">
                <input type="text" v-model="item.key" placeholder="属性名" />
              </div>
              <div class="value-name">
                <input type="text" v-model="item.val" placeholder="属性值" />
              </div>
              <div>
                <el-button
                  icon="el-icon-delete"
                  circle
                  style="margin-left: 10px"
                  size="mini"
                  @click="delProp(index)"
                  title="删除"
                ></el-button>
              </div>
            </div>
          </div>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          v-if="currentType == diaglogType.add"
          @click="confirm"
          >确 定</el-button
        >
        <el-button
          type="primary"
          v-if="currentType == diaglogType.edit"
          @click="editConfirm"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
    <script>
import jsCookie from "js-cookie";
const token = jsCookie.get("token");
import * as Axios from "axios";
import { IMG_SIZE } from "../type/config";
const diaglogType = {
  add: "1",
  edit: "2",
};
export default {
  data() {
    return {
      height:'800px',
      Loading: false,
      dialogVisible: false,
      labelPosition: "top",
      currentType: diaglogType.add,
      cateList: [],
      props: [],
      cateDetail: null,
      headers: {
        Authorization: "Bearer " + token,
      },
      urls: {
        addUrl: "api/%s/CraftElement",
        editUrl: "api/%s/CraftElement/%Id",
      },
      diaglogType: diaglogType,
      filelist: [],
      formData: {
        name: "",
      },
      accept: "image/png, image/jpeg",
      rules: {
        name: [{ required: true, message: "请输入分类名称", trigger: "blur" }],
      },
      tableData: [],
      search: "",
      cateCurrnt: 0, //当前选择的分类
      size: IMG_SIZE,
      uploadState: false,
      uploadList: [],
      uploadCurrent: 0,
    };
  },
  created() {
    this.topo = this.$Core.getProvider("TechnologyTopo");
    this.height = window.innerHeight - 100 + "px";
    this.getDataList();
    
  },

  methods: {
    onexceed() {
      this.$message.warning("最大上传十个文件");
    },
    beforeUpload(file) {
      console.log(file);
      if (file.size > IMG_SIZE) {
        this.$message.error("图片大小不能超过5M");
        return false;
      }
      return true;
    },
    // 添加自定义属性
    addProp() {
      this.props.push({
        key: "",
        val: "",
      });
    },
    // 选择分类
    async changeCate(components) {
      this.cateList.forEach((item, index) => {
        if (item.id == components.id) {
          this.cateCurrnt = index;
        }
      });
      this.tableData = components.craftElements;
    },
    // 获取列表，组件已经包含在分类中
    async getDataList() {
      this.Loading = true;
      let cates = await this.topo.components.getCate();

      this.cateList = cates;
      this.tableData = cates[this.cateCurrnt].craftElements.reverse();

      this.cateDetail = cates[this.cateCurrnt];
      this.Loading = false;
    },
    // 添加组件
    addComponent() {
      if (!this.cateDetail) {
        this.$message.error("请选择分类");
        return;
      }
      this.props = [];
      this.urls.addUrl = this.urls.addUrl.replace("%s", this.cateDetail.id);
      this.currentType = diaglogType.add;
      this.formData.name = "";
      this.dialogVisible = true;
    },
    // 编辑组件
    handleEdit(_, row) {
      this.urls.editUrl = this.urls.editUrl.replace("%s", this.cateDetail.id);
      this.urls.editUrl = this.urls.editUrl.replace("%Id", row.id);
      this.currentType = diaglogType.edit;
      this.formData.id = row.id;
      this.formData.name = row.name;
      let json = JSON.parse(row.data || "{}");
      let data = [];
      // 格式化自定义属性
      Object.keys(json).forEach((key) => {
        let obj = {
          key: key,
          val: json[key],
        };
        data.push(obj);
      });

      this.props = data;
      this.dialogVisible = true;
    },
    handleDelete(index, row) {
      if (!confirm("确定删除吗？")) return;
      this.topo.components
        .delComponent(this.cateDetail.id, row.id)
        .then((res) => {
          if (res.success) {
            this.tableData.splice(index, 1);
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    // 上传文件
    async uploadHttpRequest(evt) {
      let formData = new FormData();
      formData.append("file", evt.file);
      formData.append("Data", evt.data.Data);
      //   上传多张图片将以文件名为组件名
      if (this.$refs.upload.uploadFiles.length > 1) {
        formData.append("name", evt.file.name.split(".")[0]);
      } else {
        formData.append("name", evt.data.name);
      }

      //   return;
      // 禁止上传超过5M的图片
      if (evt.file.size > this.size) {
        this.$message.error("图片大小不能超过5M");
        return;
      }

      if (this.currentType == diaglogType.edit) {
        // 修改
        Axios.put(this.urls.editUrl, formData, {
          headers: this.headers,
        })
          .then((res) => {
            evt.onSuccess(res.data);
          })
          .catch((err) => {
            evt.onError(err.data);
          });
      } else {
        this.uploadList.push(formData);

        if (this.uploadList.length == this.$refs.upload.uploadFiles.length) {
            this.dialogVisible = false;
            this.Loading = true
          const upload = () => {
            // 上传
            Axios.post(this.urls.addUrl, this.uploadList[this.uploadCurrent], {
              headers: this.headers,
            })
              .then((res) => {
                this.uploadCurrent++;
                if (this.uploadCurrent < this.uploadList.length) {
                  setTimeout((_) => {
                    upload();
                  }, 1500);
                }else{
                    this.uploadCurrent = 0;
                    this.uploadList = []
                    this.success(res.data);
                }
              })
              .catch((err) => {
                this.error(err.data);
              });
          };
          upload();
        }
      }
    },
    // 选中
    toggleSelection(rows) {
      if (rows) {
        this.tableData.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    success(res) {
      if (res.success) {
        this.dialogVisible = false;
      } else {
        this.$message.error(res.message);
      }

      this.getDataList();
    },
    error(err) {
      this.$message.error("网络请求错误");
    },
    editConfirm() {
      let data = {};
      this.props.forEach((item) => {
        data[item.key] = item.val;
      });
      this.formData.Data = JSON.stringify(data);
      if (
        !this.$refs.upload.uploadFiles ||
        !this.$refs.upload.uploadFiles.length
      ) {
        this.$message.error("请上传图片");
      } else {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.$refs.upload.submit();
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      }
    },
    // 删除自定义属性
    delProp(index) {
      this.props.splice(index, 1);
    },
    confirm() {
      if (!this.cateDetail) {
        this.$message.error("请选择分类");
        return;
      }
      //   默认属性
      let data = {
        visible: true,
        width: 100,
        height: 100,
        name: "image",
        lineWidth: 0,
        radio: true,
        imageRatio: true,
        isBottom: true,
      };
      this.props.forEach((item) => {
        data[item.key] = item.val;
      });
      this.formData.Data = JSON.stringify(data);
      if (
        !this.$refs.upload.uploadFiles ||
        !this.$refs.upload.uploadFiles.length
      ) {
        this.$message.error("请上传文件");
        return;
      }

      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$refs.upload.submit();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    selectChange(e) {
      this.selectList = e;
    },
    //   删除所有
    delAll() {
      if (!confirm("确认删除所有数据？")) return;
      this.Loading = true;
      let all = [];
      this.selectList.forEach(async (item, index) => {
        all.push(
          this.topo.components.delComponent(this.cateDetail.id, item.id)
        );
      });

      Promise.all(all)
        .then((res) => {
          this.Loading = false;
          this.$message.success("删除成功");
          this.getDataList();
        })
        .catch((_) => {
          this.Loading = false;
        });
    },
  },
};
</script>
    <style lang="scss" scoped>
.table-content {
  margin-top: 20px;
  background: #323232;
}
.prop-content {
  .props-item {
    display: flex;
    align-items: center;
    input {
      border: 1px solid #ccc;
      padding: 5px;
      width: 100%;
      box-sizing: border-box;
      border-radius: 5px;
    }
    .key-name {
      width: 100px;
      box-sizing: border-box;
      margin-right: 10px;
    }
    .value-name {
      width: 150px;
    }
  }
}
</style>